/**
 * Read a sanitized error message from a failed Response. Falls back to a
 * generic `Request failed (status)` when the body has no `error` field or the
 * JSON parse fails, so raw DB errors / stack traces never reach the client.
 */
export async function readJsonError(res: Response): Promise<string> {
  const body = (await res.json().catch(() => ({}))) as { error?: string };
  return body.error ?? `Request failed (${res.status})`;
}
